import { UnknownKeyValuePairs } from './types'
/**
 * Composition Selector.
 */
export const badges = (attributes: UnknownKeyValuePairs, properties: UnknownKeyValuePairs): {mhd:boolean, bStock:boolean} => {
    const mhd = attributes.core.mhdSale === '1'
    const bStock = properties.groups[471]?.options[0]?.name === 'B-Ware' || properties.groups[471]?.options[0]?.name === 'B-zboží'
    return { mhd: mhd, bStock: bStock }
}
